module.exports = __webpack_public_path__ + "static/media/medalj.504e69d1.mp3";